import { css, injectGlobal } from "react-emotion/macro"
import { mq, color } from "./variables"
import { input } from "./form-fields"

injectGlobal`
  body.component-overlay-is-active {
    overflow: hidden;
  }
`

export const searchOverlay = css`
  width: 100vw;
  min-height: 100vh;
  overflow: scroll;
  background: rgba(255, 255, 255, 0.98);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 999999;

  > div {
    padding-top: 60px;
    padding-bottom: 60px;

    .btn {
      position: absolute;
      top: 60px;
      right: 15px;
    }

    h2 {
      text-align: left;
    }

    .logo-wrapper {
      margin: 60px auto 0;
      text-align: center;

      img {
        width: 200px;
        max-width: 100%;
      }
    }

    .meta {
      display: flex;
      flex-direction: column;
      font-weight: 400;
      font-size: 14px;

      span:first-of-type {
        margin-top: 10px;
      }

      span {
        line-height: 1.35;
      }
    }

    .ais-SearchBox-input {
      ${input};

      &:hover,
      &:focus {
        box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.15);
      }
    }

    .search-container {
      max-width: 800px;
      margin: 0 auto;
    }

    .ais-SearchBox-form {
      margin-bottom: 30px;
    }

    .ais-Hits-item {
      ${input};
      width: 100%;
      line-height: 1.35;
      margin-left: 0;
      margin-right: 0;
      padding: 0;
      display: flex;
      transition: background 0.5s ease;

      a {
        padding: 15px;
        width: 100%;

        &:hover {
          text-decoration: none;
          background-color: ${color.rgba.purple(0.1)[1]};
        }
      }
    }

    .ais-Hits-list {
      margin: 0;
    }

    ${mq.sm(css`
      h2 {
        text-align: center;
      }

      .btn {
        right: 60px;
      }

      .ais-Hits-item {
        width: calc(50% - 15px);
        margin-left: 0;

        &:nth-of-type(odd) {
          margin-right: 30px;
        }
      }
    `)};
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/angoliaSearch.js